import React from 'react';
import {Song} from '../../../../../../../types';
import styles from './ResourceMetadata.module.scss'

interface Props {
  name: string;
  creatorName: string;
  tracks: Song[];
  trackCount: number;
}

export function ResourceMetadata({
  name,
  creatorName,
  tracks,
  trackCount,
}: Props) {
  const creatorNamesMarkup = creatorName;

  const duration = durationLabel(tracks);

  return (
    <>
      <div className={styles.Title}>{name}</div>
      <div className={styles.CreatorName}>{creatorNamesMarkup}</div>
      <div className={styles.TracksDetails}>{`${trackCount} songs, ${duration}`}</div>
    </>
  );
}

function pluralized(word: 'minute' | 'hour', count: number) {
  if (count === 1) {
    return word;
  } else {
    return word + 's';
  }
}

function durationLabel(songs: Song[]) {
  const lengthInMs = songs.reduce((sum, song: Song) => {
    return sum + song.duration;
  }, 0);

  const lengthInMinutes = Math.floor(lengthInMs / 60000);

  const hours = Math.floor(lengthInMinutes / 60);
  const minutes = lengthInMinutes % 60;

  const hoursText = pluralized('hour', hours);
  const minutesText = pluralized('minute', minutes);

  const hoursLabel = `${hours} ${hoursText}`;
  const minutesLabel = `${minutes} ${minutesText}`;

  if (hours > 0 && minutes > 0) {
    return `${hoursLabel}, ${minutesLabel}`;
  }
  if (hours > 0 && minutes === 0) {
    return hoursLabel;
  }
  if (hours === 0 && minutes > 0) {
    return minutesLabel;
  }
}
